import React, { useState } from 'react';
import { AiAssistantChat } from './AiAssistantChat';

interface AiAssistantToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const AiAssistantToggle: React.FC<AiAssistantToggleProps> = ({ isOpen, onToggle }) => {
  return (
    <AiAssistantChat 
      isOpen={isOpen} 
      onToggle={onToggle} 
    />
  );
};